<template>
    <card headerStyle="primary" title="Tags">

        <AutoComplete v-model="formTags.name" :suggestions="suggestions" :dropdown="true" class="w-100 mb-3"
            placeholder="Add a tag..." @complete="filterTags" @keyup.enter="saveTag" @item-select="tagSelected"
            field="label" />

        <template v-for="tag in (draft ? draftTags : savedTags)">
            <div class="btn-group mr-1 mb-1" role="group">
                <jet-button class="btn-short bg-light text-secondary text-nowrap border-right-0">
                    {{ tag.name }}
                </jet-button>
                <jet-button class="btn-short bg-light text-secondary text-nowrap border-left-0" icon="fas fa-times"
                    @click="deleteTag(tag.id)">
                </jet-button>
            </div>
        </template>
    </card>
</template>

<script>
import JetInput from '@/Jetstream/Input'
import JetButton from '@/Jetstream/Button'
import AutoComplete from 'primevue/autocomplete'

export default {
    components: {
        JetButton,
        JetInput,
        AutoComplete,
    },
    props: {
        tags: {
            type: Array,
            default: [],
        },
        savedTags: {
            type: Array,
            default: [],
        },
        userIds: Array,
        modelValue: Array,
        draft: false,
    },
    emits: ['update:model-value'],
    data() {
        let tags = this.tags;

        if (this.savedTags.length) {
            let savedTagIds = this.savedTags.map(tag => tag.id);
            tags = tags.filter((tag) => {
                return !savedTagIds.includes(tag.value);
            });
        }

        return {
            name: '',
            formTags: this.$inertia.form({
                user_ids: this.userIds,
                name: '',
            }),
            tagOptions: tags,
            suggestions: tags,
            draftTags: [],
        };
    },
    methods: {
        filterTags(e) {
            this.suggestions = this.tagOptions.filter((tag) => {
                return tag.label.toLowerCase().includes(e.query.toLowerCase());
            });
        },
        saveTag() {
            if (this.draft) {
                this.$nextTick(() => {
                    if (this.formTags.name && !this.draftTags.find(t => t.name.toLowerCase() == this.formTags.name)) {
                        this.draftTags.push({ name: this.formTags.name, id: Date.now() })
                        this.$emit('update:model-value', this.draftTags);
                    }
                })
                return;
            }
            this.formTags.user_ids = this.userIds;
            this.formTags.post(route('admin.userTags.store'), {
                preserveScroll: true,
                onSuccess: () => {
                    this.formTags.reset();
                    this.suggestions = this.tagOptions;
                }
            });
        },
        tagSelected(event) {
            this.formTags.name = event.value.label;
            this.saveTag();
        },
        deleteTag(tagId) {
            if (this.draft) {
                this.$nextTick(() => {
                    this.draftTags = this.draftTags.filter(t => t.id != tagId);
                    this.$emit('update:model-value', this.draftTags);
                })
                return;
            }
            this.$inertia.form({
                user_ids: this.userIds,
                tag_id: tagId,
            }).delete(route('admin.userTags.delete'), {
                preserveScroll: true
            });
        },
    }
}
</script>
